import React, { Component } from 'react';
import './Navbar.css';
import {Icon, Button, Dropdown, NavItem, Modal, Input } from 'react-materialize';
import {NavLink} from 'react-router-dom';
import AuthService from '../services/AuthService';
import {ConnectPlayer, UnconnectPlayer} from '../services/ConnectService';
import logo from '../logo.svg';

class Navbar extends Component {
  	state ={
  		token: null,
  		Auth: new AuthService(),
  		cpf: '',
  		open: false,
  		openRemove: false
  	}

  	openAdd = () => {
  		this.setState({open: true})
  		this.setState({openRemove: false})
  	}

  	openRemove = () => {
  		this.setState({open: false})
  		this.setState({openRemove: true})
  	}

	Logout = () => {
		this.state.Auth.removeToken();
		window.location.replace("/login");
	}

	close = () => {
		this.setState({open: false});
		this.setState({openRemove: false})
	}

	addPlayer = () => {
		const { cpf } = this.state;

		if(cpf !== 0){
			ConnectPlayer(cpf)
			this.close()
		}
	}

	removePlayer = () => {
		const { cpf } = this.state;

		if(cpf !== 0){
			UnconnectPlayer(cpf)
			this.close()
		}
	}

	render() {
		const display = {display: 'block', top: '10%', height: '35%' };
		const hide = {display: 'none'};
		return (
			<div>
				<div className="navbar-fixed">
					<nav className="navbar z-depth-0">
						<div className="nav-wrapper">
							<a className="brand-logo"><img className="logo" src={logo} alt="logo"></img></a>
					        <ul id="nav-mobile" className="right hide-on-med-and-down">
								<li><NavLink to="/home" activeClassName="selected" className="btn">Home</NavLink></li>
								<li>
									<div className='drop'>
										<NavLink to="/gerenciar" activeClassName="selected" className="btn">Gerenciar Usuários</NavLink>
										<div className='drop-content' >
											<NavItem href="#" onClick={() => this.openAdd()}>Adicionar Participante</NavItem>
											<NavItem href="#" onClick={() => this.openRemove({openRemove: true})}>Remover Participante</NavItem>
										</div>
									</div>
								</li>
								<li><NavLink to="/chat" activeClassName="selected" className="btn">Interação</NavLink></li>
								<li><NavLink to="/incentivar" activeClassName="selected" className="btn">Planos de incentivo</NavLink></li>
								<li><Button className="btn" onClick={this.Logout}>Logout</Button></li>
								<li>
					          		<Dropdown trigger={
										<a href="#" className='clear'><Icon>settings</Icon></a>
									}>
										<NavItem href="#" onClick={() => this.setState({open: true})}>Adicionar Participante</NavItem>
									</Dropdown>
								</li>
					        </ul>
					        <Dropdown trigger={
						        <a href="#" className="sidenav-trigger" style={window.innerWidth > 992 ? {display: 'none'} : {display: 'block',color: 'black', width: 200}}><i className="material-icons">menu</i></a>
						    } >
								<NavLink to="/home">Home</NavLink>
								<NavLink to="/gerenciar">Gerenciar Usuários</NavLink>
								<NavLink to="/chat">Interação</NavLink>
								<NavLink to="/incentivar">Planos de incentivo</NavLink>
								<NavItem onClick={this.Logout}>Logout</NavItem>
							</Dropdown>
						</div>
					</nav>

					<Modal
						header='Adicionar Usuario'
						fixedFooter
						actions={
							<div>
								<Button className="btn waves-effect waves-light btn-flat modal-action modal-close" onClick={this.close}>Close</Button>
								<Button className="btn waves-effect waves-light btn-flat modal-action modal-close" onClick={this.addPlayer}>Add</Button>
							</div>
						}
						style={ this.state.open ? display : hide}>
						<Input label="cpf" onChange={(e) => this.setState({cpf: e.target.value})} />
					</Modal>

					<Modal
						header='Remover Usuario'
						fixedFooter
						actions={
							<div>
								<Button className="btn waves-effect waves-light btn-flat modal-action modal-close" onClick={this.close}>Close</Button>
								<Button className="btn waves-effect waves-light btn-flat modal-action modal-close" onClick={this.removePlayer}>Remove</Button>
							</div>
						}
						style={ this.state.openRemove ? display : hide}>
						<Input label="cpf" onChange={(e) => this.setState({cpf: e.target.value})} />
					</Modal>
				</div>
			</div>
		);
	}


}


export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar.js